export type EducatorsGradeKey = "k2" | "35";

export type FeaturedGame = {
  title: string;
  description: string;
  href: string;
  imageSrc: string;
  cardClassName?: string;
};

export const featuredGamesByGrade: Record<EducatorsGradeKey, FeaturedGame[]> = {
  k2: [
    {
      title: "Monopoly Jr",
      description: "A classic way for kids to play with money and property.",
      href: "/games/monopoly-jr",
      imageSrc: "/images/marketing/educators/greatGames/monopolyJr.webp",
    },
    {
      title: "Small Numbers",
      description: "Young kids learn math with blocks and bubbles.",
      href: "/games/mm-small-numbers",
      imageSrc: "/images/marketing/educators/greatGames/smallNumbers.webp",
    },
    {
      title: "Piggy Bank",
      description: "Kick-start your kid's financial future with coin math.",
      href: "/games/piggy-bank",
      imageSrc: "/images/marketing/educators/greatGames/piggyBank.webp",
    },
  ],
  "35": [
    {
      title: "Star Stuff",
      description: "Logic puzzles have never been more fun and immersive!",
      href: "/games/star-stuff",
      imageSrc: "/images/marketing/educators/greatGames/starStuff.webp",
    },
    {
      title: "Super Chesslike Adventure",
      description: "Enjoy a new take on chess that every kid can enjoy!",
      href: "/games/super-chesslike-adventure",
      imageSrc: "/images/marketing/educators/greatGames/superChesslikeAdventure.webp",
    },
    {
      title: "Changemaker",
      description: "Learn how to handle money like a real cashier!",
      href: "/games/changemaker",
      imageSrc: "/images/marketing/educators/greatGames/changemaker.webp",
    },
  ],
};

export const gradeBlurbs: Record<EducatorsGradeKey, string> = {
  "35": "As students in grades 3–5 grow, learning strategy helps them analyze situations and anticipate consequences. They practice making informed decisions and organizing information. Strategic thinking also builds perseverance, creativity, and adaptability, supporting success across subjects and real world problem solving.",
  k2: "Teaching strategy through games helps K–2 students develop essential critical thinking and problem solving skills in an engaging way. As children learn to plan ahead, consider outcomes, and adjust their choices, they strengthen early decision making abilities that support both academic learning and social development.",
};
